import toast from "react-hot-toast"

export const groupByKey = (list, key) => list.reduce((hash, obj) => ({...hash, [obj[key]]:( hash[obj[key]] || [] ).concat(obj)}), {})


export const getOrderSum = (data, key) => {
    if (data) {

        return data
            .map((d) => (isNaN(d[key]) ? 0 : Number(d[key])))
            .reduce((a, b) => a + b, 0)
    }
}

export const getImageURL=(imageUrl)=>{


    if(imageUrl=='' || imageUrl==null ){
        return null
    }else if(imageUrl?.includes('blob')){
      return imageUrl
    }else {
        const url = 'http://maelano.info/api/v1';
        const validExtensions = ['jpg', 'jpeg', 'png', 'gif'];
        
        if (!imageUrl.startsWith('uploads/')) {
            imageUrl = `uploads/${imageUrl}`;
        }
        
        const hasValidExtension = validExtensions.some(ext => imageUrl.toLowerCase().endsWith(`.${ext}`));
        
        // Add '.png' extension if no valid extension found
        if (!hasValidExtension) {
            imageUrl += '.png';
        }
        
        return `${url}/${imageUrl}`;
    }
}

export const myToast = (myPromise) => {

    return toast.promise(myPromise, {
        loading: 'Loading, Please Wait',
        // success: 'Data Inserted Successfully',
        success: (data) => `${data.message}`,
        error: (data) => `${data.message}`
    },
    {
        success: {
          duration: 3000 // Adjust the duration the success message is displayed
        }
    }
    )
}


export const toFormatDateWOTime=(passDate)=>{
    
    const date= new Date(passDate)

    const year= date.getFullYear()
    // const month= date.getMonth()+1
    // const day= date.getDate()
    // const hours = date.getHours();
    // const minutes = date.getMinutes();
    
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    // const finalDate= month+'/'+day+'/'+year
// 05/24/2023 -- OUTPUT

const finalDate = `${day}/${month}/${year}`;
    // Example output: 05/24/2023 10:47

    // const date = new Date(passDate);

    // const year = date.getFullYear();
    // const month = (date.getMonth() + 1).toString().padStart(2, '0');
    // const day = date.getDate().toString().padStart(2, '0');
    // const hours = date.getHours().toString().padStart(2, '0');
    // const minutes = date.getMinutes().toString().padStart(2, '0');

    // const finalDate = `${month}/${day}/${year} ${hours}:${minutes}`;
    // // Example output: 01/15/2024 10:47

    return finalDate
}

export const formatLikes = (num) => {
    if (num >= 1000 && num < 1000000) {
        return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
      } else if (num >= 1000000) {
        return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
      } else {
        return num.toString();
      }    
  };


export const paymentOptions = [
    { value: 'credit_debit_2345', label: 'Credit/Debit card (Ending with 2345)' },
    { value: 'credit_debit_8768', label: 'Credit/Debit card (Ending with 8768)' },
    { value: 'paypal', label: 'Paypal' },
    { value: 'meezan_bank_2567', label: 'Meezan bank account (Ending with 2567)' },
    { value: 'jazzcash_4533', label: 'Jazzcash (Ending with 4533)' },
  ];

  export const addPaymentOptions = [
    { value: 'credit_debit', label: 'Credit/Debit card' },
    { value: 'bank_account', label: 'Bank Account' },
    { value: 'paypal', label: 'Paypal' },
    { value: 'jazzcash', label: 'Jazzcash/Easy Paisa' },
];


export const genderOptions = [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' },
    { value: 'other', label: 'Other' },
]